export type CanadaTaxRate = {
  // Province display name.
  province: string;
  // Province code used in addresses.
  code: string;
  // Federal GST rate.
  federal: number;
  // Federal tax label (e.g., GST/TPS).
  federalLabel?: string;
  // Provincial component (PST/HST portion).
  provincial: number;
  // Provincial tax label (e.g., PST/TVQ/HST).
  provincialLabel?: string;
  // Total tax rate (federal + provincial).
  total: number;
};

// Current Canadian sales tax rates by province/territory.
export const CANADA_TAX_RATES: CanadaTaxRate[] = [
  { province: 'Alberta', code: 'AB', federal: 5, federalLabel: 'GST', provincial: 0, total: 5 },
  { province: 'British Columbia', code: 'BC', federal: 5, federalLabel: 'GST', provincial: 7, provincialLabel: 'PST', total: 12 },
  { province: 'Manitoba', code: 'MB', federal: 5, federalLabel: 'GST', provincial: 7, provincialLabel: 'PST', total: 12 },
  { province: 'New Brunswick', code: 'NB', federal: 0, provincial: 15, provincialLabel: 'HST', total: 15 },
  { province: 'Newfoundland and Labrador', code: 'NL', federal: 0, provincial: 15, provincialLabel: 'HST', total: 15 },
  { province: 'Nova Scotia', code: 'NS', federal: 0, provincial: 15, provincialLabel: 'HST', total: 15 },
  { province: 'Northwest Territories', code: 'NT', federal: 5, federalLabel: 'GST', provincial: 0, total: 5 },
  { province: 'Nunavut', code: 'NU', federal: 5, federalLabel: 'GST', provincial: 0, total: 5 },
  { province: 'Ontario', code: 'ON', federal: 0, provincial: 13, provincialLabel: 'HST', total: 13 },
  { province: 'Prince Edward Island', code: 'PE', federal: 0, provincial: 15, provincialLabel: 'HST', total: 15 },
  { province: 'Quebec', code: 'QC', federal: 5, federalLabel: 'TPS', provincial: 9.975, provincialLabel: 'TVQ', total: 14.975 },
  { province: 'Saskatchewan', code: 'SK', federal: 5, federalLabel: 'GST', provincial: 6, provincialLabel: 'PST', total: 11 },
  { province: 'Yukon', code: 'YT', federal: 5, federalLabel: 'GST', provincial: 0, total: 5 },
];
